/*@ngInject*/
const LazyLoadDropdownController = function ($scope, $element, localization, dropdownMediator, coreConstant) {

    this.$onInit = function () {
        this.isLoading = this.isLoading === 'true' || this.isLoading === true;

        /**
         * begin dropdown controller
         */
        this.isDisabled = this.isDisabled === true || this.isDisabled === 'true';
        this.selectedOption = this.selectedOption || {};
        this.searchTerm = this.searchTerm || '';
        this.placeholder = this.placeholder || '';
        this.required = this.required === true || this.required === 'true' || false;

        localization.setupLocale('component', require('../../../../ui/dropdown/dropdown.i18n.json'));

        this.feedbackMessage = '';
        this.maximumOptionsError = i18n.t('component|dropdown.maximumOptionsLimitMessage', {maxOptions: this.maximumOptionsLimit});
        this.noMatchesError = i18n.t('component|dropdown.noMatchesFoundMessage');

        this.uniqueComponentClass = this.className + 'DropdownComponent';

        $element.addClass('umDropdownContainer');
        $element.addClass('lazyLoadDropdown');
        $element.addClass(this.uniqueComponentClass);
        $element.addClass(this.componentClassName);

        this.validateOptionList();

        /**
         * end dropdown controller
         */
    };

    this.$onChanges = function (changes) {
        const dropdownSelectedValueState = dropdownMediator.getDropdownSelectedValueState(changes, this.selectedOption, this.optionList, this.placeholder);

        if (!_.isNil(dropdownSelectedValueState)) {
            this.selectedOption = dropdownSelectedValueState.selectedOption;
            this.dropdownButtonDisplayText = dropdownSelectedValueState.dropdownButtonDisplayText;
        }

        let valueArray = _.split(this.selectedOption.value, '::');
        if (valueArray[0] === 'externalID') {
            this.hasBusinessCard = false;
            this.hasOrganizationCard = false;
        }

        if (this.hasBusinessCard) {
            this.businessCardUserId = !_.isNil(this.selectedOption.value) ? parseInt(this.selectedOption.value) : null;
        }
        if (this.hasOrganizationCard) {
            this.businessCardOrganizationId = !_.isNil(this.selectedOption.value) ? parseInt(this.selectedOption.value) : null;
        }

        this.validateOptionList();
    };

    this.toggleOptionList = function (event) {
        if (!event.originalEvent.repeat) {
            this.isOptionListOpen = !this.isOptionListOpen;

            if (this.isOptionListOpen) {
                this.onOpen();
            } else {
                $scope.setFocus('.' + this.uniqueComponentClass + ' .umDropdownButton button', event);
            }
        }
    };

    this.isDropdownListVisible = function () {
        return !this.isLoading && this.feedbackMessage === null;
    };

    this.onSearchTermChanged = function (searchTerm) {
        this.searchTerm = searchTerm;
        this.onSearch({searchTerm: searchTerm});
    };

    this.isClearButtonEnabled = function () {
        const isLoading = this.isLoading; // new in this impl
        const hasValueSelected = !_.isEmpty(this.selectedOption.name);

        return !isLoading && hasValueSelected;
    };

    this.onSelectedOptionChange = function (option) {
        this.selectedOption = option;
        this.toggleOptionList({originalEvent: {repeat: false}});
        this.onChange({selectedOption: this.selectedOption});
    };

    /**
     * begin dropdownController
     */

    this.validateOptionList = function () {
        if (!_.isNil(this.optionList)) {
            const numberOfOptions = _.get(this.optionList, 'length');
            const maximumOptionsLimitReached = numberOfOptions >= this.maximumOptionsLimit;
            const hasZeroOptions = numberOfOptions === 0;
            const hasPositiveCount = this.optionListCount > 0;

            if (hasZeroOptions) {
                if(hasPositiveCount) {
                    this.feedbackMessage = i18n.t('component|dropdown.maximumOptionsLimitMessage', {maxOptions: this.optionListCount});
                } else {
                    this.feedbackMessage = this.noMatchesError;
                }
            } else if (maximumOptionsLimitReached) {
                this.filteredOptionList = [];
                this.feedbackMessage = this.maximumOptionsError;
            } else {
                this.feedbackMessage = null;
            }
        }
        const hasFeedbackMessageOverride = !_.isEmpty(this.feedbackOverride);
        if (hasFeedbackMessageOverride) {
            this.feedbackMessage = this.feedbackOverride;
        }
    };

    this.onClearSelectedOption = function () {
        this.selectedOption = {};
        this.toggleOptionList({originalEvent: {repeat: false}});
        this.onChange({selectedOption: null});
    };

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED, () => {
        if (this.isOptionListOpen) {
            this.onClearSelectedOption();
        }
    });

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLOSE, (event) => {
        if (this.isOptionListOpen) {
            this.toggleOptionList({originalEvent: {repeat: false}})
        }
    });

    /**
     * end dropdownController
     */
};

angular.module('umFormViewer')
    .controller('umLazyLoadDropdownController', LazyLoadDropdownController);
